import { Container, Box, Grid, Link as MaterialLink, Typography } from "@mui/material"

const FooterLink = ({ url, label, size, m=0, p=1 }) => {
  return(
    <MaterialLink 
      href = {url}
      ml = {m}
      mr = {m}
      pl = {p} 
      pr = {p}
      sx = {{
        color: "black",
        textDecoration: "none",
        '&:hover': {
          color: "black",
          backgroundColor: "#00000015",
          cursor: "crosshair",
          textDecoration: "none"
        }
      }}
    >
      <Typography fontFamily="inherit" fontSize={size}>
        {label}
      </Typography>
  </MaterialLink>
  )
}

const FooterSpacer = () => {
  return(
    <Typography m={-0.2}>{'\u00b7'}</Typography>
  )
}

const Footer = () => {
  let date = new Date()
  const jr = {xs: 'center', sm: 'right'}
  const jl = {xs: 'center', sm: 'left'}
  return (
    <Container maxWidth={false} disableGutters>
      <Box width="100%" color="black" sx={{minHeight: "250px"}}>
        <Box pt={20} pl={5} pr={5} pb={2}>
          <Grid container>
            <Grid container item xs={12} sm={6} pb={2} justifyContent={jl}>
              <Box>
                <Box fontFamily="Paper" display="flex" justifyContent={jl}>
                  <FooterLink url={"https://twitter.com/pxlqart"} label={"social"} size="0.95rem"/>
                  <FooterSpacer/>
                  <FooterLink url={"/disclaimer"} label={"disclaimer"} size="0.95rem"/>
                  <FooterSpacer/>
                  <FooterLink url={"/privacy"} label={"privacy"} size="0.95rem"/>
                  <FooterSpacer/>
                  <FooterLink url={"mailto:contact@randomwalk.online"} label={"contact"} size="0.95rem"/>
                </Box>
              </Box>
            </Grid>
            <Grid container item xs={12} sm={6} pb={0} justifyContent={jr} sx={{pointerEvents: "none"}}>
              <Box fontFamily="General Sans">
                <Box justifyContent={jr}> 
                  <Typography textAlign={jr} fontFamily="inherit" fontSize="1.0rem" fontWeight={800}>
                    All Rights Reserved
                  </Typography>
                </Box>
                <Box justifyContent={jr} sx={{pointerEvents: "all"}}> 
                  <Typography textAlign={jr} fontFamily="inherit" fontSize="0.9rem">
                    &copy;<span>{date.getFullYear()}</span> by 
                      <MaterialLink 
                        href = "https://randomwalk.online"
                        target = "_blank"
                        rel = "noreferrer"
                        size = "0.8rem"
                        pl = {0.3}
                        sx = {{
                          textDecoration: "none",
                          "&:hover": {
                            cursor: "crosshair",
                            fontWeight: 400,
                            textDecoration: "underline"
                          }
                        }}
                      >
                        Random Walk
                      </MaterialLink>
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box display="flex" pt={0} pb={0} mr={-1} justifyContent={jr} fontFamily="General Sans"> 
            <Typography mr={-0.5} fontFamily="inherit" fontSize="0.8rem">
              Site content is licensed under    
            </Typography>
            <FooterLink m={0.5} p={0.5} url="https://creativecommons.org/licenses/by-nc/4.0/deed.en" label="CC BY-NC 4.0" size="0.8rem"/> 
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

export default Footer